<div class="tooltip-container" [attr.data-type]="type">
  <div
    class="tooltip-box"
    [attr.data-type]="type"
    [innerHTML]="tooltip.description"
    #tooltipContainer
  ></div>

  <hdi-icon
    *ngIf="type === 'click'"
    class="close-button"
    (click)="closeTooltip($event)"
    (keydown)="closeTooltip($event)"
    iconName="close"
    [size]="Sizes.MEDIUM"
    [color]="Colors.WHITE"
    [isHover]="true"
  ></hdi-icon>
</div>
